import { UPDATE_PMR_MARKER_DATA } from "./pmrMarkerDataReducer"

export const updatePmrMarkerData = (info) => ({
    type: UPDATE_PMR_MARKER_DATA,
    payload: info
})